<template>
    <div class="current-day-for-timeline">
        <IconCurrentPosition class="current-day-for-timeline__icon" />
    </div>
</template>

<script>
import IconCurrentPosition from '@/views/track/icons/IconCurrentPosition.vue';

export default {
    name: 'CurrentDayForTimeline',
    components: {
        IconCurrentPosition,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.current-day-for-timeline {
    position: absolute;
    bottom: 0;
    left: 0;
    width: urem(2);
    height: calc(100% + #{urem(50)});
    background-color: #69609f;
    z-index: 1;

    &__icon {
        position: absolute;
        top: urem(-10);
        left: 50%;
        transform: translateX(-50%);
        width: urem(42);
        height: urem(48);
    }
}
</style>
